// Chat Action Types
export const SET_ROOMS = 'chat/SET_ROOMS';
export const ADD_ROOM = 'chat/ADD_ROOM';
export const SET_ACTIVE_ROOM = 'chat/SET_ACTIVE_ROOM';
export const SET_MESSAGES = 'chat/SET_MESSAGES';
export const ADD_MESSAGE = 'chat/ADD_MESSAGE';
export const SET_TYPING = 'chat/SET_TYPING';
export const SET_UNREAD_COUNT = 'chat/SET_UNREAD_COUNT';
export const CLEAR_UNREAD = 'chat/CLEAR_UNREAD';
export const SET_LOADING = 'chat/SET_LOADING';
export const SET_ERROR = 'chat/SET_ERROR';
export const RESET_CHAT = 'chat/RESET_CHAT';

// Action Creators
export const setRooms = (rooms) => ({
    type: SET_ROOMS,
    payload: rooms
});

export const addRoom = (room) => ({
    type: ADD_ROOM,
    payload: room
});

export const setActiveRoom = (roomId) => ({
    type: SET_ACTIVE_ROOM,
    payload: roomId
});

export const setMessages = (roomId, messages) => ({
    type: SET_MESSAGES,
    payload: { roomId, messages }
});

export const addMessage = (message) => ({
    type: ADD_MESSAGE,
    payload: message
});

export const setTyping = (roomId, userId, userName, isTyping) => ({
    type: SET_TYPING,
    payload: { roomId, userId, userName, isTyping }
});

export const setUnreadCount = (roomId, count) => ({
    type: SET_UNREAD_COUNT,
    payload: { roomId, count }
});

export const clearUnread = (roomId) => ({
    type: CLEAR_UNREAD,
    payload: roomId
});

export const setLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading
});

export const setError = (error) => ({
    type: SET_ERROR,
    payload: error
});

export const resetChat = () => ({
    type: RESET_CHAT
});

export default {
    setRooms,
    addRoom,
    setActiveRoom,
    setMessages,
    addMessage,
    setTyping,
    setUnreadCount,
    clearUnread,
    setLoading,
    setError,
    resetChat
};
